import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAi = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	fill: "#000000",
	id: "Capa_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	viewBox: "0 0 321.492 321.492",
	xmlSpace: "preserve",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", { d: "M296.635,165.204h-26.861V9c0-4.971-4.029-9-9-9H84.409c-2.599,0-5.072,1.124-6.781,3.082L18.076,71.315 c-1.431,1.64-2.219,3.742-2.219,5.918v235.259c0,4.971,4.029,9,9,9h235.917c4.971,0,9-4.029,9-9v-25.778h26.861 c4.971,0,9-4.029,9-9v-103.51C305.635,169.233,301.606,165.204,296.635,165.204z M287.635,268.714H94.497v-85.51h193.139V268.714z  M140.831,164.383L140.831,164.383v-19.486c6.075-2.544,10.344-8.542,10.344-15.541c0-6.998-4.269-12.997-10.344-15.541V92.774 c4.074-1.706,7.334-4.966,9.041-9.041h46.092c1.706,4.074,4.967,7.335,9.041,9.041v21.041c-6.075,2.544-10.344,8.543-10.344,15.541 c0,6.998,4.269,12.997,10.344,15.541v19.485v0c0,0.279,0.023,0.552,0.058,0.821h-64.289 C140.807,164.935,140.831,164.662,140.831,164.383z M75.409,32.999v35.234H44.657L75.409,32.999z M251.774,303.492H33.857V86.233 h50.552c4.971,0,9-4.029,9-9V18h158.365v147.204h-33.827c0.034-0.27,0.058-0.542,0.058-0.821v-19.486 c6.075-2.544,10.344-8.543,10.344-15.541s-4.269-12.997-10.344-15.541V92.774c6.075-2.544,10.344-8.543,10.344-15.541 c0-9.303-7.541-16.844-16.844-16.844c-6.998,0-12.997,4.269-15.541,10.344h-46.092c-2.544-6.075-8.543-10.344-15.541-10.344 c-9.302,0-16.844,7.541-16.844,16.844c0,6.998,4.269,12.997,10.344,15.541v21.041c-6.075,2.544-10.344,8.543-10.344,15.541 s4.269,12.997,10.344,15.541v19.486c0,0.279,0.023,0.552,0.058,0.821H85.497c-4.971,0-9,4.029-9,9v103.51c0,4.971,4.029,9,9,9 h166.277V303.492z" }),
		/* @__PURE__ */ _jsx("path", { d: "M172.235,200.112l-18.617,52.216h11.49l3.636-10.763h19.271l3.345,10.763h11.854l-18.399-52.216H172.235z M171.653,232.547 l6.691-20.653h0.145l6.473,20.653H171.653z" }),
		/* @__PURE__ */ _jsx("rect", {
			x: 209.328,
			y: 200.112,
			width: 10.909,
			height: 52.216
		})
	] })]
});
const ForwardRef = forwardRef(SvgAi);
export { ForwardRef as ReactComponent };
